// Sdílená instance QueryClientu.
//
// Ve vlastním modulu (ne v App.tsx), aby se k ní dostal i non-React kód —
// hlavně `sessionReset`, který při přihlášení/odhlášení musí zahodit cache
// předchozího řidiče (jinak nový řidič uvidí cizí trasu z `route/today`).
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
